// extracted by mini-css-extract-plugin
export default {"styledDivider":"FooterLinks_styledDivider__E64-r","styledLink":"FooterLinks_styledLink__jP7sN"};